import { Argenta } from '@argenta-types/homebank';

import { JobDetailUrls } from '../../../types/config.types';
import { VacanciesResponseInterface, VacancyInterface } from '../../types/vacancies.types';

const buildVacancyDetailsUrl = (
  language: Argenta.HomeBank.Global.I18n.Language,
  jobReference: string,
  jobDetailUrls: JobDetailUrls
): string =>
  language === 'nl' ? `${jobDetailUrls.nl}${jobReference}` : `${jobDetailUrls.fr}${jobReference}`;

const stripHtml = (html: string): string => {
  const elementPlaceholder = document.createElement('DIV');
  elementPlaceholder.innerHTML = html;
  // eslint-disable-next-line unicorn/prefer-dom-node-text-content
  return elementPlaceholder.textContent || elementPlaceholder.innerText || '';
};

const getVacancyDetailsLink = (
  vacancy: VacancyInterface,
  language: Argenta.HomeBank.Global.I18n.Language,
  isInIframe: boolean,
  jobDetailUrls: JobDetailUrls
): string | undefined => {
  return isInIframe ? buildVacancyDetailsUrl(language, vacancy.id, jobDetailUrls) : undefined;
};

export const mapLinkVacancies = (
  language: Argenta.HomeBank.Global.I18n.Language,
  response: VacanciesResponseInterface | undefined,
  isInIframe: boolean,
  jobDetailUrls: JobDetailUrls
): VacanciesResponseInterface | undefined => {
  if (!response) {
    return response;
  }

  return {
    vacancies: response.vacancies.map((data) => ({
      ...data,
      description: stripHtml(data.description),
      link: getVacancyDetailsLink(data, language, isInIframe, jobDetailUrls),
    })),
  };
};
